import { FormEvent, useState } from 'react';
import searchImg from '../img/search2.gif';

function Search({ onSearch, placeholder }: { onSearch: (q: string) => void; placeholder: string }) {
    const [search, setSearch] = useState('');
    const onSubmit = (e: FormEvent) => {
        e.preventDefault();
        // @ts-ignore
        const input = (e.target as HTMLFormElement).elements['search'];
        const val = input.value;
        onSearch(val);
    };
    return (
        <div className="iek-prodcat-catalog-search-form">
            <form onSubmit={onSubmit}>
                <input
                    name="search"
                    className="iek-prodcat-catalog-search-form__input"
                    type="text"
                    placeholder={placeholder}
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
                <input
                    type="image"
                    className="iek-prodcat-catalog-search-form__input-img"
                    src={searchImg}
                    alt="Искать"
                    readOnly
                />
            </form>
        </div>
    );
}

export default Search;
